import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../registration.service';
import { environment } from '@env/environment';
// import { threadId } from 'node:worker_threads';
// import { error } from 'node:console';

@Component({
  standalone: false,
  selector: 'app-phone-update-recovery-email',
  templateUrl: './phone-update-recovery-email.component.html',
  styleUrls: ['./phone-update-recovery-email.component.scss']
})
export class PhoneUpdateRecoveryEmailComponent implements OnInit {
  recoveryEmailForm = new FormGroup({
    recoveryEmail: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
    ])
  });

  // Toast message properties
  showToast: boolean = false;
  toastMessage: string = '';
  toastType: 'success' | 'error' = 'success';
  isLoading: boolean = false;
  recoveryEmailTooltip = false;
  private toastTimer: any;
  genericMessages: any[] = [];
  errorMessages: any[] = [];
  genericMessage: any = {};
  errorMessage: any = {};
  toastMessages: any[] = [];
  toastDbMessage: any = {};
  emailError: boolean = false;
  isButtonActive: boolean = true;

  get isSubmitDisabled(): boolean {
    return this.recoveryEmailForm.invalid || this.isLoading || this.isButtonActive;
  }

  // Store email from query parameters to preserve it
  private currentEmail: string = '';
  private phone: string = '';
  private currentRecoveryEmail: string = '';
isEmailFocused: any;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly registrationService: RegistrationService
  ) {
    // Capture email from query parameters when component loads
    this.route.queryParams.subscribe(params => {
      if (params['email']) {
        this.currentEmail = params['email'];
      }
      if(params['phone']){
        this.phone = params['phone'];
      }
      if(params['recoveryEmail']){
        this.currentRecoveryEmail = params['recoveryEmail'];
      }
    });
  }
 ngOnInit(): void {
  const storedErrorMessages = window.localStorage.getItem('errorMessages');   
      this.errorMessages = JSON.parse(storedErrorMessages);
        this.errorMessage = {};
    this.errorMessages.forEach(message => {
      if (message.key && message.value !== undefined) {
        this.errorMessage[message.key] = message.value;
      }
    });
    const storedGenericMessages = window.localStorage.getItem('genericMessages');
      this.genericMessages = JSON.parse(storedGenericMessages);
        this.genericMessage = {};
    this.genericMessages.forEach(message => {
      if (message.key && message.value !== undefined) {
        this.genericMessage[message.key] = message.value;
      }
    });
    const storedToastMessages = window.localStorage.getItem('toastMessages');
      this.toastMessages = JSON.parse(storedToastMessages);

      this.toastDbMessage = {};
      this.toastMessages.forEach(message => {
        if (message.key && message.value !== undefined) {
          this.toastDbMessage[message.key] = message.value;
        }
      });
  }

  onSubmit() {
    if (this.recoveryEmailForm.valid) {
      this.isLoading = true;
      const recoveryEmail = this.recoveryEmailForm.get('recoveryEmail')?.value;
      console.log('Recovery email updated:', recoveryEmail);
      let request = {
        email: this.currentEmail,
        recoveryEmail: recoveryEmail
      };
      this.registrationService.updaterecoveryNewEmail(request).subscribe({
        next: response => {
          console.log('API Response:', response); // Debug log  
          if (response.data.success === true) {
            // Show success toast
            this.emailSend();
            this.sendRecoveryEmailVerification();
      
            // Call the email notification API
            const updatedRecoveryEmail = this.recoveryEmailForm.get('recoveryEmail')?.value;

        // Preserve both email and recovery email parameters
        const queryParams: any = {};
        if (this.currentEmail) {
          queryParams.email = this.currentEmail;
        }
        queryParams.phone = encodeURIComponent(this.phone);
        queryParams.recoveryEmail = encodeURIComponent(updatedRecoveryEmail);
          setTimeout(() => {
            this.router.navigate(['/login']); 
          }, 15000);
        }
      },
      error: error => {
        console.error('Error Updating Recovery Email:', error);
      }
    });
        //   relativeTo: this.route,
        //   queryParams: queryParams
        // });
    } else {
      console.log('Form is invalid');
    }
  }
sendRecoveryEmailVerification() {
    let request = {
      email: this.recoveryEmailForm.get('recoveryEmail')?.value
    };
    
    this.registrationService.recoveryEmailVerification(request).subscribe({
      next: response => {
        console.log('Recovery email verification sent successfully:', response);
        console.log('OTP email sent to recovery email address');
      },
      error: error => {
        console.error('Error sending recovery email verification:', error);

      }
    });
  }
   emailSend() {
    const recoveryEmail = this.recoveryEmailForm.get('recoveryEmail')?.value;
    let request = {
      email: this.currentEmail ,
      primary_phone: this.phone ,
      recovery_email: recoveryEmail,
      front_end_domain: environment.frontEndDomain
    };
    this.registrationService.updateRecoveryEmailNotification(request).subscribe({
      next: response => {
        console.log('API Response:', response); // Debug log
        
        // Since the email is being sent successfully, treat any non-error response as success
        console.log('email sent successfully');
        this.showToastMessage('A new confirmation link has been sent to your email. Please check your inbox and Spam/Junk folders.', 'success');
      },
      error: error => {
        console.error('Error sending email notification:', error);
      }
    });
  }

  get recoveryEmailControl() {
    return this.recoveryEmailForm.get('recoveryEmail');
  }

  showToastMessage(message: string, type: 'success' | 'error' = 'success'): void {
    this.toastMessage = message;
    console.log('Toast Message:😂', message); // Debug log
    this.toastType = type;
    this.showToast = true;

    // Auto-hide toast after 3 seconds and navigate only on success
    this.toastTimer = setTimeout(() => {
      this.closeToast();
    
    }, 5000);
  }

  closeToast(): void {
    this.showToast = false;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }
    checkEmail() {
    let request = {
      email: this.recoveryEmailForm.get('recoveryEmail')?.value
    };
    let validEmail = validateEmailforApiCall(request.email);
    function validateEmailforApiCall(email: string):boolean {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; 
      console.log('Email validation result:', emailPattern.test(email));
      return emailPattern.test(email);
    }
  if(request.email && validEmail){
      this.registrationService.checkEmail(request).subscribe({
      next: response => {
        console.log('API Response:', response); // Debug log
        if (response.data.exists === true) {
          this.isButtonActive = true;
          this.emailError = true;
          this.showToastMessage(this.toastDbMessage['T0003'], 'error');
          setTimeout(() => {
            this.emailError = false;
          }, 5000);
          // this.router.navigate(['']);
        } else {
          this.emailError = false;
          this.isButtonActive = false;
          
        }
      }
    });
  }
  }

  onCancel(): void {
   this.router.navigate(['../phone-recovery-email'], {
      relativeTo: this.route,
      queryParams: {
        email: this.currentEmail,
        phone: this.phone,
        recoveryEmail: this.currentRecoveryEmail
      }
    });
  }
}

